import { render, staticRenderFns } from "./BtwMessageBox.vue?vue&type=template&id=34d719c4&scoped=true&"
import script from "./BtwMessageBox.vue?vue&type=script&lang=js&"
export * from "./BtwMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./BtwMessageBox.vue?vue&type=style&index=0&id=34d719c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d719c4",
  null
  
)

export default component.exports